export default "immagini/logo-completo-semplice-HB+UnaHotels.svg"